import { sortBy } from 'lodash';
import { useMemo } from 'react';
import { isQANotification } from '../../../filters/notifications/isQANotification';
import { useEventNotifications } from '../useEventNotifications';

export function useEventQAAnswerNotifications(eventId, questionId, { filter, sortBy: sortFunction } = {}) {
    const notifications = useEventNotifications(eventId, {
        filter: isQANotification,
    });
    return useMemo(() => {
        let result = notifications.filter((notif) => notif.content?.data?.questionId == questionId);

        if (filter) result = result.filter(filter);
        if (sortFunction) result = sortBy(result, sortFunction);

        return result;
    }, [notifications]);
}
